import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { EMPTY_VALUE } from '../../../utils/common'
import { HighlightInformation } from '../../common/header/highlightInformation'
import { HIGHLIGHT_KEYS, PANEL_ID } from '../helper'
import { selectHighlight, selectLoading } from '../store/slice'

export const Highlight = () => {
  const data = useSelector(selectHighlight())
  const isLoading = useSelector(selectLoading('highlight'))

  const formatDetailData = ({ data, highlightKey }) => {
    switch (HIGHLIGHT_KEYS[highlightKey]) {
      case HIGHLIGHT_KEYS.COMPANY_FILINGS:
        return (
          <Element className="cursorDefault" style={{ color: '#3A414B' }}>
            <Translate value="filingStatus.IN_THE_PAST_5_YEARS" />
          </Element>
        )
      default:
        return data[HIGHLIGHT_KEYS[highlightKey]] || EMPTY_VALUE
    }
  }

  const getScrollElementId = (key) => {
    switch (HIGHLIGHT_KEYS[key]) {
      case HIGHLIGHT_KEYS.INVOICE_ENFORCEMENT:
      case HIGHLIGHT_KEYS.OVERDUE_TAX_DEBT:
        return PANEL_ID.OVERDUE_TAX_DEBT
      case HIGHLIGHT_KEYS.OVERDUE_SOCIAL_INSURANCE:
        return PANEL_ID.OVERDUE_SOCIAL_INSURANCE
      default:
        return ''
    }
  }

  const highlights = Object.keys(HIGHLIGHT_KEYS).map((key, index) => {
    return {
      title: UseI18n('filingStatus.' + key),
      detail: formatDetailData({ data, highlightKey: key }),
      isShowSeparator: index !== Object.keys(HIGHLIGHT_KEYS).length - 1,
      scrollElementId: getScrollElementId(key),
    }
  })

  return <HighlightInformation highlights={highlights} isLoading={isLoading} />
}
